import React, { useState, useEffect } from 'react'
import Cookies from 'universal-cookie'
import { getBaseURL } from '../../URLs'
import DropDownList from './DropDownList'

export default (props) => {
    const [locations, setLocations] = useState([])
    const [coRoot, setcoRoot] = useState('')
    const cookies = new Cookies(document.cookie)

    useEffect(() => {
        setcoRoot(cookies.get('CoRoot'))
        if (
            sessionStorage.getItem(`stateLocations${coRoot}`) &&
            sessionStorage.getItem(`stateLocations${coRoot}`) !== 'false' &&
            sessionStorage.getItem(`stateLocations${coRoot}`) !== 'null'
        ) {
            setLocations(JSON.parse(sessionStorage.getItem(`stateLocations${coRoot}`)))
        } else {
            var xhr = new XMLHttpRequest()
            xhr.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    if (
                        !sessionStorage.getItem(`stateLocations${coRoot}`) ||
                        sessionStorage.getItem(`stateLocations${coRoot}`) === 'false' ||
                        sessionStorage.getItem(`stateLocations${coRoot}`) === 'null'
                    ) {
                        var response = JSON.parse(this.responseText)
                        sessionStorage.setItem(`stateLocations${coRoot}`, JSON.stringify(response))
                    }

                    setLocations(JSON.parse(sessionStorage.getItem(`stateLocations${coRoot}`)))
                }
            }
            xhr.open('GET', `${getBaseURL()}webapi/warehouseget/warehouse/`, true)
            xhr.withCredentials = true
            xhr.send()
        }
    }, [])

    if (!locations) {
        return <></>
    }

    return (
        <DropDownList
            {...props}
            key={`${props.id}_ddlLocations`}
            options={[
                {
                    locnum: '',
                    name: 'Select Location',
                    whtype: '',
                },
                ...locations,
            ].map((location, i) =>
                location.locnum === '' ||
                (props.awclocationsonly &&
                    (location.whtype.trim() === 'SO' || location.whtype.trim() === '') &&
                    location.bo_support.trim() !== '' &&
                    location.PublishLocation) ||
                (!props.awclocationsonly && location.whtype.trim() !== 'SO') ? (
                        <option key={i} value={location.locnum.trim()}>{`${
                            location.locnum.trim() !== '' ? location.locnum.trim() + ' - ' : ''
                        }${location.name.trim()}`}</option>
                    ) : null
            )}
        />
    )
}
